import { render, staticRenderFns } from "./transcript.vue?vue&type=template&id=07a21350&scoped=true"
import script from "./transcript.vue?vue&type=script&lang=js"
export * from "./transcript.vue?vue&type=script&lang=js"
import style0 from "./transcript.vue?vue&type=style&index=0&id=07a21350&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a21350",
  null
  
)

export default component.exports